export default __webpack_public_path__ + "static/underline-22-ec57f8ab3ae737bd5ef2d8ca56da1b37.svg";